import { call, delay } from "redux-saga/effects";

const RETRYABLE_STATUSES = [502, 503, 504];

// Network errors (e.g. net::ERR_NETWORK_CHANGED, offline) have no response;
// gateway errors often show up while the connection is being restored.
export const isRetryableNetworkError = (error) => {
    if (!error || !error.isAxiosError) {
        return false;
    }

    return !error.response || RETRYABLE_STATUSES.includes(error.response.status);
};

export function* callWithNetworkRetry(fn, args = [], {
    retries = 20,
    baseDelay = 2000,
    maxDelay = 15000,
    onRetry,
} = {}) {
    for (let attempt = 0; ; attempt++) {
        try {
            return yield call(fn, ...args);
        } catch (error) {
            if (attempt >= retries || !isRetryableNetworkError(error)) {
                throw error;
            }
            if (onRetry) {
                yield call(onRetry, attempt + 1, error);
            }
            yield delay(Math.min(baseDelay * 2 ** attempt, maxDelay));
        }
    }
}
